import styled from 'styled-components'

import { Link } from 'react-router-dom';

import { ReactComponent as Clock } from 'assets/icons/hours-icon.svg'

export const Container = styled.div``

export const Content = styled.main`
  width: calc(100% - 176px);
  height: fit-content;
  margin-left: 176px;
  padding: 72px 0 50px;

  position: relative;

  @media (max-width: 1170px){
    width: 100%;
    margin: 0 0 50px 0;
  }
`
export const ReturnButton = styled(Link)`
  position: absolute;
  top: 29px;
  left: 32px;

  .faq__content-icon{
    height: 20px;
    width: auto;
    stroke: #000;
  }
`

export const SectionAgenda = styled.section`
  width: 98%;
  // max-width: 966px;
  max-width: 1080px;
  margin: 0 auto;

  display: flex;
  gap: 56px;

  .agenda-section__calendar-container{
    width: 100%;
    max-width: 466px;
    height: fit-content;

    overflow: hidden;
    border-radius: 15px;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.31);
  }

  .agenda-section__calendar-header{
    width: 95%;
    height: 60px;
    margin: 0 auto;

    position: relative;

    display: flex;
    gap: 40.6px;
    align-items: center;
  }

  .agenda-section__calendar-header-button{
    border: 0;
    outline: none;
    background-color: transparent;
    cursor: pointer;
  }

  .agenda-section__calendar-header__select-container{
    position: absolute;
    bottom: -50px;

    display: flex;
    flex-direction: column;
    z-index: 5;
  }

  .agenda-section__calendar-date{
    height: fit-content;

    font-size: 1.5625rem;
    line-height: 1.5625rem;
    font-weight: normal;
    color: var(--blue00);
    text-transform: uppercase;
  }

  .agenda-section__calendar-date-strong{
    font-weight: bold;
  }

  .ant-picker-calendar{
    width: 95%;
    height: 100%;
    margin: 0 auto;
  }

  .ant-picker-cell,
  .ant-picker-cell-in-view{
    width: 14%;
    height: 50px;

    font-size: 1.3125rem;
  }

  .ant-picker-cell-selected{
    .ant-picker-cell-inner{
      box-shadow: 0 0 5px rgba(0, 0, 0, 0.30);
    }
  }

  .ant-picker-cell-in-view:not(.ant-picker-cell-selected){
    .ant-picker-cell-inner{
      color: var(--blue31);
    }
  }

  .ant-picker-cell-inner{
    width: 90%;
    height: auto !important;
    aspect-ratio: 56.76 / 58.59;
    margin: 0 auto;
    padding: 10.5px 0 7.9px;

    position: relative;

    display: block !important;

    border-radius: 6px !important;
    overflow: hidden;
  }

  .ant-picker-calendar-date-value{
    position: relative;
    z-index: 2;
  }

  .agenda-section__cell-inner-monthday{
    position: relative;
    top: 35px;

    line-height: 0.75rem;
    font-size: 0.75rem;
  }

  .agenda-section__cell-inner-monthday-container{
    margin: 0;
    padding: 0;

    position: absolute;
    inset: 0;
    list-style: none;
    z-index: 1;

    color: #fff;
    background-color: var(--blue00);
  }

  .agenda-section__aside{
    width: 100%;
    // max-width: 444px;
    max-width: 500px;
    height: fit-content;
    min-height: 458px;
    padding: 41.1px 0;

    background-color: var(--bluef0);
    border-radius: 24px;
  }

  .agenda-section__aside-article{
    width: 90%;
    height: fit-content;
    margin: 0 auto;
    padding: 18.9px 19.7px 24.9px;

    position: relative;

    border-radius: 7px;
    background-color: #fff;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);

    &:not(:first-child){
      margin: 26.2px auto;
    }
  }

  .agenda-section__aside-article-wrapper{
    width: 97%;
    height: 100%;
    margin: 0 auto;

    display: flex;
    gap: 18.5px;
  }

  .agenda-section__aside-article__product-photo-button {
    background: transparent;
    border: 0;

    width: 48px;
    height: 48px;

    align-self: flex-start;

    cursor: pointer;
  }

  .agenda-section__aside-article__product-photo{
    width: 48px;
    height: 48px;
    flex: none;
    margin-top: 10px;

    border-radius: 6px;

    object-fit: cover;

    display: block;

  }

  .agenda-section__aside-article__content-wrapper{
    display: block;
  }

  .agenda-section__aside-article__content-text{
    color: var(--blue00);
    font-size: 0.9375rem;
    line-height: 1.1875rem;
  }

  .agenda-section__aside-article__content-time{
    margin-top: 13.5px;

    color: #001383;

    display: block;
  }

  .agenda-section__aside-article__content-text-b{
    text-transform: uppercase;
  }

  .agenda-section__aside-article__content-solicitation-info{
    color: #001383;

    margin: 8px 0;
  }

  .agenda-section__aside-article__content-button{
    position: absolute;
    right: 12.2px;
    bottom: 12.2px;

    color: var(--blue00);
    background-color: transparent;
    border: 0;
    cursor: pointer;
  }

  @media (max-width: 1170px){
    flex-direction: column;
  }
`

export const ClockIcon = styled(Clock)`
  width: 25px;
  height: 25px;
  flex: none;
  margin-top: 10px;

  display: block;
`
